
import Vue from "vue";
import axios from "axios";
import anime from 'animejs';

import { QueuesSummary, UserDashboard }  from '../../../types/Sapphire_dto';

export default Vue.extend({
  name: "dashboard-queue-list",
  props: {
    usr: String,
    fac: String
  },
  data: function() {
    return {
      widthModifier: 'one-third',
      heightModifier: '',
      sortByName: false,
      isErrored: false,
      isLoading: false,
      queues: [] as QueuesSummary[]
    };
  },
  mounted() {
    if (localStorage.dbQueueSortName) {
      this.sortByName = localStorage.dbQueueSortName == 'true' ? true : false ;
    }
  },
  computed: {
    dashboardWidthModifier(): string {
      return 'dashboard-' + this.widthModifier + '-item-div';
    },
    sortedQueues(): QueuesSummary[] {
      let temp: QueuesSummary[] = this.queues;
      temp.sort((a, b) => {
        if (this.sortByName) {
          let fa = a.QueueName.toLowerCase(), fb = b.QueueName.toLowerCase()
            
            if (fa < fb) {
              return -1
            }
            if (fa > fb) {
              return 1 
            }
            return 0
        } 
        // Sort by value
        else {
          if (a.QueueCount < b.QueueCount) {
              return 1;
          }
          if (a.QueueCount > b.QueueCount) {
              return -1;
          }
          return 0;
        }
      });
      return temp
    },
  },
  watch: {
    fac: function(newVal, oldVal) {
      if (newVal != oldVal) {
         this.loadData();
      }
    },
    sortByName(newSortByName) {
      localStorage.dbQueueSortName = newSortByName;
    }
  },
  methods: {
    register(wM, hM) {
        this.widthModifier = wM;
        this.heightModifier = hM;
    },
    // init: function () {
    //     var vm = this;
    //     //if (!isLoading) {
    //     window.setTimeout(function () { vm.queues = vm.sortQueueByVal(); }, 0);
    //     //}
    // },
    buildQueueIcon(queueType) {
      if (queueType === 1) {
        //Medication
        return "/App_Themes/default1/icons/sapphire-svg-sprites.svg#svgMedQueueIcon";
      } else if (queueType === 2) {
        //Forms
        return "/App_Themes/default1/icons/sapphire-svg-sprites.svg#svgFormQueueIcon";
      } else if (queueType === 3) {
        //Patient
        return "/App_Themes/default1/icons/sapphire-svg-sprites.svg#svgPatientQueueIcon";
      } else if (queueType === 4) {
        //Vitals/Labs/Diagnosis
        return "/App_Themes/default1/icons/sapphire-svg-sprites.svg#svgVitalQueueIcon";
      } else if (queueType === 5) {
        //Clarify/Issues
        return "/App_Themes/default1/icons/sapphire-svg-sprites.svg#svgClarifyQueueIcon";
      } else if (queueType === 6) {
        //Tasks/Appointments
        return "/App_Themes/default1/icons/sapphire-svg-sprites.svg#routineIcon";
      }
      return "/App_Themes/default1/icons/sapphire-svg-sprites.svg#svgOtherQueueIcon";
    },
    changeBlockWidth(totalQueues) {
      let retVal = '';
      switch (true) {
        case this.heightModifier !== "short" && totalQueues < 10:
          retVal = "queue-single-col";
          break;
        case this.heightModifier !== "short" && totalQueues < 19:
          retVal = "queue-double-col";
          break;
        case totalQueues < 28:
          retVal= "queue-triple-col";
          break;
        case totalQueues < 37:
          retVal = "queue-quad-col";
          break;
        default:
          retVal = "queue-triple-col";
      }
      return retVal;
    },
    styleByQueueCount: function (queueCount) {
      if (queueCount >= 500) {
        return " queue-red";
      } else if (queueCount < 499 && queueCount >= 100) {
        return " queue-orange";
      }
      return null;
    },
    setQueueForEnter: function (el) {
      el.style.cssText = "opacity: 0; transform: translateY(-10px)";
    },
    queueEnter: function (el, done) {
      var delay = el.dataset.index * 75;
      anime({
        targets: el,
        opacity: 1,
        translateY: 0,
        easing: "easeOutQuad",
        duration: 400,
        delay: delay,
        complete: function () {
          done();
        },
      });
    },
    queueLeave: function (el, done) {
      var delay = el.dataset.index * 50;
      anime({
        targets: el,
        opacity: 0,
        translateY: "10px",
        easing: "easeOutQuad",
        duration: 300,
        delay: delay,
        complete: function () {
          done();
        },
      });
    },
    async loadData() {
      this.isErrored = false;
      this.isLoading = true;
      // try {
        const response = await axios.post(
          "../../../Common/Services/EmarClientOperations.svc/GetQueueSummary_Vue",
          { 
            facilityID: this.fac,
            userID: this.usr,
            currentPage: window.location.href
          }
        );
        
        let ret_response: UserDashboard = JSON.parse(response.data.d);
        this.queues = ret_response.QueuesCount || [];
      // } catch (err) {
      //   this.isErrored = true;
      // }
      
      this.isLoading = false;
      return this.queues;
    },
  },
});
